import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeBot, setDomainState, setSelectedBot, setSelectedDomain } from "../../../state/actions/domain";
import { DomainSwitcher } from "../../ui/Modals/DomainSwitcher";
import { clearSelectedConversation, createChatBotConversation, setActiveMessageChatArea, setActiveMessageChatAreaDetail, setSelectedOnetoOneChat } from "../../../state/actions/chats";
import { getAuthData, getFromLocalStorage, removeFromLocalStorage, updateDataInStorage } from "../../../services/storage/LocalStorage";
import { setCloseAssistantBot, setHideChatwidget, setHideDefaultHomepageBot, setOpenAssistantBot, setShowDefaultHomepageBot } from "../../../state/actions/bot";
import { setBotWaitLoader } from "../../../state/actions/loader";
import { menuItems } from "./SidebarManager/staticUtils";
import { useNavigate } from "react-router-dom";
import { setHeaderTitle } from "../../../state/actions/layout";
import { LFStorageKeys } from "../../../services/storage/LFStorage";

import ActivateEnterpriseBots from "../../catalog/providers/ActivateEnterpriseBots";
import ModalPopup from "../../ui/Modals/ModalMessages/ModalPopup";
import SideIconComponent from "./SidebarManager/SideIconComponent";
import SideMenu from "./SidebarManager/SideMenu";
import SideBarHeader from "./SidebarManager/SideBarHeader";
import authFunctions from "../../../services/userApiServices/authFunctions";
import { resetTabStack, setTabState } from "../../../state/actions/tabStack";
import { getPageName, setPageTitle } from "../../../utils/general";
import SideFooter from "./SidebarManager/SideFooter";
import store from "../../../state/configureStore";
import Config from "../../../utils/config/config";
import { pushNotificationGenerator } from "../../../state/actions/user";
import {withOutInitSocket} from "../../../state/actions/socket"
import { SEAMEDEX_TYPE, VIKAND, VIKAND_DIRECT, VIKAND_DIRECT_STAGE } from "../../../utils/constants";
import webSocketApiService from "../../../services/socket/wsApiServices";

const Sidebar = ({ }) => {
  const [activeItem, setActiveItem] = useState("App Marketplace"); //show active item
  const [expandedItems, setExpandedItems] = useState(new Set());
  const [showHeaderDropdown, setShowHeaderDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [defaultBot, setDefaultBot] = useState(null); // Track default bot
  const [showNewProvider, setShowNewProvider] = useState(false);
  const location = window.location
  const accepted = useSelector((state) => state.contacts.accepted);
  const isSideBar = useSelector((state) => state.layout.isSideBar);
  let domainLists = useSelector((state) => state?.domain?.domains);
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const botSubscriptions = useSelector((state) => state.user?.botSubscriptions);
  const selectedDomainDetails = useSelector((state) => state.domain.selectedDomainDetails);
  const profileImages = useSelector((state) => state.profileImages);
  const selectedBotDetails = useSelector((state) => state.domain.selectedBotDetails);
  const selectedBot = useSelector((state) => state.bot?.selectedBot); // Get selected bot from Redux
  const headerTitle = useSelector((state) => state.layout.headerTitle);
  const isDefaultHomePageBot = useSelector((state) => state.bot.isDefaultHomePageBot);
  const withoutInitSocket = useSelector((state) => state.socket.withoutInitSocket);
  const isAssistantBotOpen = useSelector((state) => state.bot.isAssistantBotOpen);
  const urlParams = new URLSearchParams(window.location.search);
  const botIdFromUrl = urlParams.get("botId");
  const [menuList, setMenuList] = useState(menuItems);
  const [domainList, setDomainList] = useState(domainLists);
  const authData = getAuthData();
  const user = authData?.user || null;
  let inital = false
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = getPageName();
  let baseURL = `${Config.gRPCURL}/grpc/user.UserService/RegisterWebApp`;

  const isDefaultBot = (bot) => {
    return bot?.isDefault || bot?.name === 'Assistant' || bot?.id === defaultBot?.id;
  };


  useEffect(() => {
    if (!domainLists || !selectedDomainDetails) return;

    const lockInUsers = store.getState()?.domain?.selectedDomainDetails?.lockInUsers;

    const updatedDomainList = lockInUsers
      ? domainLists.filter(domain => domain.userDomain !== 'frontmai')
      : domainLists;

    setDomainList(updatedDomainList); // Assuming domainList is state
  }, [selectedDomainDetails, domainLists]);

  // Function to determine if a bot is currently selected
  const isSelectedBot = (bot) => {
    return selectedBot && (selectedBot.id === bot.id || selectedBot.name === bot.name);
  };

  // Function to get bot highlighting classes
  const getBotHighlightClasses = (bot, isActive = false) => {
    const baseClasses = "transition-all duration-200";

    if (isSelectedBot(bot)) {
      return `${baseClasses} bg-blue-600 border-l-4 border-blue-300 text-white shadow-lg`;
    }

    if (isDefaultBot(bot)) {
      return `${baseClasses} bg-blue-500 bg-opacity-30 border-l-2 border-blue-400 text-blue-100`;
    }

    if (isActive) {
      return `${baseClasses} bg-blue-400 bg-opacity-20 text-blue-50`;
    }

    return `${baseClasses} hover:bg-blue-400 hover:bg-opacity-20 text-gray-200`;
  };

  useEffect(() => {
    if (pathname === "Profile") {
      setActiveItem('');
    }
  }, [navigate]);

  // Check if mobile/tablet
  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      // Mobile: <768px, Tablet (iPad): 768px - 1023px, Desktop: >=1024px
      if (width < 768 || width < 1024) {
        setIsMobile(true); // Mobile
      } else {
        setIsMobile(false); // Desktop
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);


  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (isMobile && isOpen && !event.target.closest(".sidebar-container")) {
        setIsOpen(false);
      }
    };

    if (isMobile && isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
      document.addEventListener("touchstart", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("touchstart", handleOutsideClick);
    };
  }, [isMobile, isOpen, setIsOpen]);


  // Set default bot on mount and when botSubscriptions change
  useEffect(() => {
    if (botSubscriptions && botSubscriptions.length > 0) {
      // Find default bot or set first one as default
      const defaultBotItem = botSubscriptions.find(bot => bot.isDefault) || botSubscriptions[0];
      setDefaultBot(defaultBotItem);
    } else {
      setDefaultBot(null);
    }
  }, [botSubscriptions]); // Added botSubscriptions as dependency


  // Restore selected state from localStorage on component mount
  useEffect(() => {
    const savedHeaderTitle = getFromLocalStorage(LFStorageKeys.HEADER_TITLE);
    const savedSelectedBotStr = getFromLocalStorage(LFStorageKeys.SELECTED_BOT);
    const savedActiveItem = getFromLocalStorage(LFStorageKeys.ACTIVE_ITEM);

    if (savedHeaderTitle && typeof savedHeaderTitle === 'string') {
      dispatch(setHeaderTitle(savedHeaderTitle));
    }

    // Only restore bot selection if we have bot subscriptions and the saved bot exists in current domain
    if (savedSelectedBotStr && typeof savedSelectedBotStr === 'string' && botSubscriptions?.length > 0) {
      try {
        const parsedBot = JSON.parse(savedSelectedBotStr);
        // Check if the saved bot exists in current domain's bot subscriptions
        const botExistsInCurrentDomain = botSubscriptions.some(bot =>
          bot.id === parsedBot.id || bot.name === parsedBot.name
        );

        if (botExistsInCurrentDomain) {
          dispatch(setSelectedBot(parsedBot));
        } else {
          // Clear invalid bot selection
          removeFromLocalStorage(LFStorageKeys.SELECTED_BOT);
        }
      } catch (error) {
        console.error('Error parsing saved bot data:', error);
        removeFromLocalStorage(LFStorageKeys.SELECTED_BOT);
      }
    };

    if (pathname === "Contacts") {
      window.document.title = "Contacts";
      setActiveItem('Contacts');
    } else if (pathname === "Messages") {
      window.document.title = "Messages";
      setActiveItem('Messages');
    } else if (!savedActiveItem && !isDefaultHomePageBot) {
      setActiveItem('App Marketplace');
    } else {
      if (window.location.pathname.includes('chats')) {
        setActiveItem(savedActiveItem);
      }
      if (savedActiveItem?.includes('-')) {
        const parentName = savedActiveItem.split('-')[0];
        setExpandedItems(prev => new Set([...prev, parentName]));
        setActiveItem(savedActiveItem);
      }
    }

  }, []);

  //set shimmer loader fasle if there is no bot context 
  useEffect(() => {
    if (!["Catalog_Featured", "Catalog_Categories", "Home"].includes(pathname)) {
      dispatch(setBotWaitLoader(false));
    }
  }, [pathname]);


  useEffect(() => {
    if (isDefaultHomePageBot && window.location.pathname.includes('chats')) {
      setActiveItem("Home")
    }
    else {
      // const activeItemValue = `App Marketplace-${headerTitle}`;
      // if (activeItemValue) setActiveItem(activeItemValue)
    }
  }, [headerTitle, botSubscriptions, selectedDomainDetails, isDefaultHomePageBot])


  const toggleHeaderDropdown = () => {
    const newShowHeaderDropdown = !showHeaderDropdown;
    setShowHeaderDropdown(newShowHeaderDropdown);

    if (newShowHeaderDropdown) {
      setExpandedItems(new Set());
    }
  };


  const toggleExpanded = (itemName) => {
    const newExpanded = new Set(expandedItems);
    if (newExpanded.has(itemName)) {
      newExpanded.delete(itemName);
    } else {
      newExpanded.add(itemName);
    }
    setExpandedItems(newExpanded);
  };


  const handleItemClick = (item) => {
    dispatch(setCloseAssistantBot());
    dispatch(setHideChatwidget());
    dispatch(setHideDefaultHomepageBot());
    removeFromLocalStorage(LFStorageKeys.SELECTED_BOT);
    removeFromLocalStorage(LFStorageKeys.ACTIVE_ITEM);
    dispatch(removeBot());

    if (item === "Contacts") {
      setPageTitle();
      setActiveItem("Contacts")
      dispatch(setHeaderTitle('Contacts'))
      dispatch(resetTabStack());
      if (pathname !== "Contacts") navigate('/app/contacts');
    } else if (item === "Messages") {
      setPageTitle();
      setActiveItem("Messages")
      removeFromLocalStorage(LFStorageKeys.SELECTED_BOT);
      removeFromLocalStorage(LFStorageKeys.ACTIVE_ITEM, item);
      dispatch(setHeaderTitle('Connect'))
      dispatch(resetTabStack());
      if (pathname !== "Messages") navigate('/app/messages');
    }
    else {
      if (item && item.slug == "app_marketplace") {
        navigate("/app/catalog/");
        dispatch(removeBot());
        dispatch(setHeaderTitle("Apps"));
      }

      if (showHeaderDropdown) {
        setShowHeaderDropdown(false);
      }

      if (item.hasSubmenu) {
        setActiveItem(item.name);
        toggleExpanded(item.name);
        updateDataInStorage(LFStorageKeys.ACTIVE_ITEM, item.name);
      }
      else {
        setActiveItem(item.name);
        updateDataInStorage(LFStorageKeys.ACTIVE_ITEM, item.name);
        // Close sidebar on mobile after selection
        if (isMobile || isSideBar) {
          setIsOpen(false);
        }
      }
    }
  };

  useEffect(() => {
    if (botIdFromUrl && botSubscriptions.length != 0 && !inital && selectedDomainDetails?.userDomain) {
      const filteredBots = botSubscriptions?.filter((bot) => bot.botId == botIdFromUrl);
      if (botIdFromUrl && filteredBots.length > 0) {
        inital = true;
        dispatch(setHideDefaultHomepageBot());
        dispatch(setTabState(true));
        dispatch(setSelectedBot(filteredBots[0]));

      }
    }
  }, [botSubscriptions, selectedDomainDetails]);


  useEffect(() => {
    if (location.pathname.includes('chats') && !isDefaultHomePageBot && !selectedBotDetails?.botName && !withoutInitSocket && !isAssistantBotOpen) {
       setActiveItem("Home");
       dispatch(setShowDefaultHomepageBot());
       dispatch(setHeaderTitle("Home"));
     
    }else if (location.pathname.includes('chats') && !isDefaultHomePageBot && selectedBotDetails?.botName) {
      const activeItemValue = `App Marketplace-${selectedBotDetails?.botName}`;
  
      // ensure it's expanded (not toggled)
      setExpandedItems(prev => {
        const updated = new Set(prev);
        updated.add('App Marketplace');
        return updated;
      });

      if (activeItemValue) setActiveItem(activeItemValue);
    } else if (location.pathname.includes('messages')) {
      setActiveItem("Messages");
    } else if (location.pathname.includes('contacts')) {
      setActiveItem("Contacts");
    } else if (['/app/settings', "/app/my-profile"].includes(location.pathname)) {
      setActiveItem(null);
    }
  }, [selectedBotDetails, location.pathname, isDefaultHomePageBot]);


  // setSelectedOnetoOneChat
  const handleSubItemClick = (subItemName, parentName = 'App Marketplace', item) => {
    dispatch(clearSelectedConversation());
    dispatch(setSelectedBot(item));
    console.log('handleSubItemClick',item)
    dispatch(setBotWaitLoader(true));
   
    if (selectedBotDetails?.botName === subItemName) {
      dispatch(setSelectedBot(item));
      updateDataInStorage(LFStorageKeys.SELECTED_BOT, JSON.stringify(item));
    }

    if (!item.conversational) {
      dispatch(setSelectedOnetoOneChat(false))
    }

    dispatch(setHideDefaultHomepageBot());
    dispatch(setTabState(true));
  dispatch(withOutInitSocket(true))
    updateDataInStorage(LFStorageKeys.HEADER_TITLE, subItemName);
    const activeItemValue = `${parentName}-${subItemName}`;
    setActiveItem(activeItemValue);
    // Save all relevant data for persistence
    updateDataInStorage(LFStorageKeys.ACTIVE_ITEM, activeItemValue);
    updateDataInStorage(LFStorageKeys.SELECTED_BOT, JSON.stringify(item));

    if (subItemName) {
      window.document.title = subItemName;
      dispatch(setHeaderTitle(subItemName))
    }

    dispatch(resetTabStack());
    dispatch(setCloseAssistantBot());
    dispatch(setHideChatwidget(true));
    dispatch(createChatBotConversation(item, user?.userId));

    // Close sidebar on mobile after selection
    if (isMobile || isSideBar) {
      setIsOpen(false);
    }

    const redirectPaths = [
      "Contacts",
      "Profile",
      "Connect",
      "Messages",
      "Settings",
      "Catalog_Categories",
    ];

    if ((redirectPaths.includes(pathname) || (pathname === "Catalog_Featured" && subItemName))) {
      navigate("/app/chats");
    }
  };

  const handleHeaderDropdownItemClick = async (itemName, item) => {
    setShowHeaderDropdown(false);
    dispatch(setCloseAssistantBot());
    dispatch(setDomainState(true))
    dispatch(setHideChatwidget(true));
    dispatch(removeBot());
    dispatch(setHideDefaultHomepageBot());
    dispatch(setSelectedDomain(item));
    dispatch(setShowDefaultHomepageBot());
    navigate("/app/chats");
    dispatch(setHeaderTitle("Home"));
    dispatch(setBotWaitLoader(true));

    localStorage.removeItem(LFStorageKeys.SELECTED_BOT)
    await webSocketApiService.UpdateLastLoggedInDomain({ userDomain: item.userDomain });
    // Close sidebar on mobile after selection
    if (isMobile || isSideBar) {
      setIsOpen(false);
    }
  };

  const handleAssistantBotNavigate = () => {
    if (selectedDomainDetails?.assistantBotConfig) {
      const botName = selectedDomainDetails?.assistantBotConfig?.name || "";
      dispatch(removeBot());
      dispatch(clearSelectedConversation());
      dispatch(setBotWaitLoader(true));
      dispatch(setActiveMessageChatArea(false));
      dispatch(setActiveMessageChatAreaDetail(null))
      dispatch(setHeaderTitle(botName));
      setActiveItem('');
      removeFromLocalStorage(LFStorageKeys.SELECTED_BOT);
      removeFromLocalStorage(LFStorageKeys.ACTIVE_ITEM);
      dispatch(setHideDefaultHomepageBot());
      dispatch(setOpenAssistantBot());
      dispatch(createChatBotConversation(selectedDomainDetails?.assistantBotConfig, user?.userId, true  ));
      if (pathname !== "Home") navigate('/app/chats');
    }
  };

  const handledefaultHomePage = (type) => {
    navigate('/app/chats');
    dispatch(removeBot())
    dispatch(setBotWaitLoader(true));
    dispatch(setHeaderTitle(type || "Home"));
    dispatch(setShowDefaultHomepageBot());
  };

  useEffect(() => {
    if (selectedDomainDetails?.userDomain) {
      let currentUserDomain = selectedDomainDetails.userDomain
      let sessionId = getAuthData()?.auth?.sessionId;
      let userEmail = getAuthData()?.user?.emailAddress;
      let webPushAppType;
      let shouldSendPushNotification = false;

      if (currentUserDomain === VIKAND || currentUserDomain === VIKAND_DIRECT || currentUserDomain === VIKAND_DIRECT_STAGE) {
        shouldSendPushNotification = true;
        webPushAppType = Config.vikandWebAppType;
      }
      if (currentUserDomain === SEAMEDEX_TYPE) {
        shouldSendPushNotification = true;
        webPushAppType = Config.seamedexAppType;
      }

      if (shouldSendPushNotification) {
        dispatch(pushNotificationGenerator({
          currentUserDomain,
          sessionId,
          webPushAppType,
          userEmail: userEmail,
          baseURL,
        }))
      }
    }
  }, [selectedDomainDetails?.userDomain]);


  return (
    <>
      {/* Mobile Overlay */}
      {(isMobile && isOpen) || (isSideBar && isOpen && (<div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" />))}

      <div
        className="sidebar-container fixed z-40 h-screen bg-primary-blue text-white flex flex-col p-[14px] transition-all ease-in-out"
        style={{ width: isMobile || isSideBar ? (isOpen ? "211px" : "76px") : "211px", transition: "width 0.2s ease-in-out" }}
      >
        {/* Header with Dropdown */}
        <SideBarHeader
          toggleHeaderDropdown={toggleHeaderDropdown}
          showHeaderDropdown={showHeaderDropdown}
          selectedDomainDetails={selectedDomainDetails}
          isMobile={isMobile}
          isSideBar={isSideBar}
        />

        {/* sideicons */}
        <SideIconComponent
          isMobile={isMobile}
          isSideBar={isSideBar}
        />

        {/* modal on click of logo */}
        {showHeaderDropdown && (
          <DomainSwitcher
            selectedDomain={selectedDomain}
            domainList={domainList}
            selectedDomainDetails={selectedDomainDetails}
            onDomainChange={handleHeaderDropdownItemClick}
            onClose={() => toggleHeaderDropdown()}
            setShowNewProvider={setShowNewProvider}
          />
        )}

        {/* Navigation Menu - Fixed scrolling container */}
        <SideMenu
          botSubscriptions={botSubscriptions}
          isMobile={isMobile}
          isSideBar={isSideBar}
          menuItems={menuList}
          activeItem={activeItem}
          selectedBot={selectedBot}
          defaultBot={defaultBot}
          acceptedContacts={accepted}
          expandedItems={expandedItems}
          handleItemClick={handleItemClick}
          handleSubItemClick={handleSubItemClick}
          allProfileImages={profileImages}
          getBotHighlightClasses={getBotHighlightClasses}
          isSelectedBot={isSelectedBot}
          isDefaultBot={isDefaultBot}
          triggerStaticBotData={handledefaultHomePage}
          selectedBotDetails={selectedBotDetails}
        />

        {/* Footer */}
        <SideFooter
          isMobile={isMobile}
          botSubscriptions={botSubscriptions}
          handleSubItemClick={handleSubItemClick}
          isSideBar={isSideBar}
          isOpen={isOpen}
          handleAssistantBotNavigate={handleAssistantBotNavigate}
          selectedDomainDetails={selectedDomainDetails}
          selectedDomain={selectedDomain}
        />

        {showNewProvider && (
          <ModalPopup onClose={() => setShowNewProvider(false)} size="sm" noHeader>
            <div className="p-2">
              <h2 className="text-gray-300 text-size-19 font-semibold"> Sign up to a new Provider</h2>
              <ActivateEnterpriseBots
                isLicenseValid={true}
                userId={user?.userId}
                onFormSubmit={() => {
                  setShowNewProvider(false);
                }}
                cancel={() => setShowNewProvider(false)}
                pathname={'/app/chats'}
              />
            </div>
          </ModalPopup>
        )}
      </div>
    </>
  );
};


export default memo(Sidebar);